import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';


const routes: Routes = [
  {
    path: 'home',
    canActivate: [authGuard],
    loadChildren: () => import('./features/home/home.module').then(m => m.HomePageModule)
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'onboarding',
    loadChildren: () => import('./features/onboarding/onboarding.module').then(m => m.OnboardingPageModule)
  },
  {
    path: 'update',
    loadChildren: () => import('./features/update/update.module').then(m => m.UpdatePageModule)
  },
  {
    path: 'quoter',
    canActivate: [authGuard],
    loadChildren: () => import('./features/quoter/quoter.module').then(m => m.QuoterPageModule)
  },

  {
    path: 'auth',
    loadChildren: () => import('./core/auth/auth.module').then(m => m.AuthPageModule)
  },
  {
    path: 'policies',
    canActivate: [authGuard],
    loadChildren: () => import('./features/policies/policies.module').then(m => m.PoliciesPageModule)
  },
  {
    path: 'user',
    canActivate: [authGuard],
    loadChildren: () => import('./features/user/user.module').then(m => m.UserModule)
  },
  {
    path: 'inspections',
    canActivate: [authGuard],
    loadChildren: () => import('./features/inspections/inspections.module').then(m => m.InspectionsPageModule)
  },

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
